export default __webpack_public_path__ + "static/media/carousel2.f22c73cd.png";